import React, { useState, useEffect, useRef } from 'react';
import { GridList, ImageListItem, ImageListItemBar, IconButton, Icon, Popover, ButtonGroup, LinearProgress, CircularProgress, Snackbar, Select, MenuItem } from '@material-ui/core';
import { get, size, last, uniqBy, keyBy, flatten, set, first, take, isEqual, isObject } from 'global/lib/lodash';
import Image from '../image';
import SearchBar from 'global/components/SearchBar';
import ModalGateway from 'global/components/ModalGateway';
import Confirm from 'global/components/confirm';
import { getBase64Image, sortAlphaNum } from 'global/utils';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import sendData from 'redux/actions/sendData';
import MuiAlert from '@material-ui/lab/Alert';
import clsx from 'clsx';
import highlightedText from 'global/components/highlight-text';
import { useStyles } from './styles';
import useDebounce from '../../hooks/useDebounce';
import Styles, { useScreen } from 'global/styles';
import CheckBoxOutlineBlankOutlined from '@material-ui/icons/CheckBoxOutlineBlankOutlined';
import CheckBox from '@material-ui/icons/CheckBox';
import { cleanCopy, downloadImage, stopProp, _size } from '../../utils';
import { awaitAll } from '../../utils/awaitAll';
import { Button } from '../Button';
import colors from '../../styles/colors';
import { Loader } from '../../styles';
import { MoreList } from '../more-drop';
import { getRealmIcon } from '../droprealms';
import FolderIcon from '@material-ui/icons/Folder';
import qs from 'qs';
import { pressedKeys } from '../../utils/keytracker';
import { useIntersect } from '../../hooks/useIntersect';
import { PhotosGrid } from '../perform-grid';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const defaultUpdates = {
  quality: undefined,
  location: undefined,
  supersets: [],
  somethingChanged: false,
};

const takeAdd = 20;

const ImageGrid = (props) => {
  const { userCanEdit, uploadPhotos, download, loading } = props;
  const folders = get(props, 'folders', []);
  // const [stateFolders, setStateFolders] = useState(folders);
  const includeSearch = get(props, 'includeSearch', false);
  const [chosenFolders, setChosenFolders] = useState([]);
  const [items, _setItems] = useState([]);
  const [allItems, _setAllItems] = useState([]);
  const [modal, setModal] = useState(false);
  const [popOpen, setPopOpen] = useState();
  const [confirm, setConfirm] = useState();
  const [dlStats, setDlStats] = useState();
  const [searchVal, setSearchVal] = useState('');
  const [alerts, setAlerts] = useState();
  const [takeAmt, setTakeAmt] = useState(takeAdd);
  const [searchStat, setSearchStat] = useState({ isSearching: false, hasSearched: false });
  const [selected, setSelected] = useState({});
  const [filts, setFilts] = useState({
    cat: 'location',
    tag: undefined,
  });
  const [updates, setUpdates] = useState(cleanCopy(defaultUpdates));
  const styles = Styles();
  const classes = useStyles();
  const debouncedSearch = useDebounce(searchVal, 750);
  const [ref, entry] = useIntersect({});
  const [btnRef, btnEntry] = useIntersect({});
  const inView = get(entry, 'isIntersecting', false);
  const [ctxtBtnsFixed, setCtxtBtnsFixed] = useState(false);
  const modalRefs = useRef({ current: null });
  const [listOpen, setListOpen] = useState(false);

  const { isMobile } = useScreen();

  const catOptions = [
    { title: 'By Location', id: 'location' },
    { title: 'By System', id: 'system' },
  ];

  const isFolders = get(items, '0.photos');

  const setItems = (its, sort = true) => {
    const it = uniqBy(its, 'id');
    _setItems(sort ? it.sort(sortAlphaNum) : it);
  };

  useEffect(() => {
    setCtxtBtnsFixed(!btnEntry.isIntersecting);
  }, [btnEntry.isIntersecting]);

  // This minor delay makes the following hook get called only after items are rendered.
  // It makes inView (bool visibility of the observer) more accurate when it's called.
  const _takeAmt = useDebounce(takeAmt, 50);
  useEffect(() => {
    if (takeAmt == 0 || (!loading && inView && takeAmt < size(items))) {
      setTakeAmt(takeAmt + takeAdd);
    }
  }, [inView, _takeAmt]);

  const setAllItems = (its) => {
    _setAllItems(uniqBy(its, 'id'));
    setTakeAmt(0);
  };

  const filterTaggedItems = (its = allItems) => {
    const _items = its.filter((it) => {
      if (it.photos) {
        return loading ? false : true;
      }
      let passes = true;
      if (filts.tag !== undefined && !get(it, 'divider')) {
        const itemQual = get(it, 'quality');
        passes = filts.tag === 'both' ? itemQual !== null : itemQual === filts.tag;
      }
      return passes;
    });
    setItems(_items, false);
  };

  useEffect(() => {
    if (get(allItems, '0.photos')) {
      filterTaggedItems();
    }
  }, [allItems]);

  const setupFolders = (clear = false) => {
    let searchfor = folders;
    const allPhotos = flatten(folders.map((f) => f.photos));
    const isFiltered = debouncedSearch || filts.tag !== undefined;
    if (isFiltered) {
      setAllItems(allPhotos);
      setFilteredItems(allPhotos);
    } else if (filts.cat === 'system') {
      const map = keyBy(
        props.supersets.map((s) => ({ ...s, photos: undefined })),
        'id'
      );
      map['null'] = {
        realm: { name: 'None' },
        icon: FolderIcon,
        photos: [],
      };
      allPhotos.map((p) => {
        if (!size(p.supersets)) {
          set(map, ['null', 'photos'], [...get(map, ['null', 'photos'], []), p]);
        }
        (p.supersets || []).map((s) => {
          set(map, [s.id, 'realm'], s);
          set(map, [s.id, 'icon'], FolderIcon);
          set(map, [s.id, 'photos'], [...get(map, [s.id, 'photos'], []), p]);
        });
      });
      const its = Object.keys(map)
        .filter((k) => !!size(get(map, [k, 'photos'])))
        .map((k) => ({
          ...map[k],
          id: `realm-${k}`,
        }));
      setAllItems(its);
      // setStateFolders(its);
      setItems(its);
      setChosenFolders();
      searchfor = its;
    } else {
      const all = folders; // [ ...folders, { divider: { text: 'All Photos' } }, ...allPhotos ];
      setAllItems(all);
      setItems(all, false);
      setChosenFolders();
    }

    if (size(chosenFolders) && !clear) {
      const found = searchfor.find((f) => f.id === get(chosenFolders, '0.id'));
      !!found && clickImage(found, -1);
    }
  };

  useEffect(() => {
    setupFolders();
  }, [folders]);

  const updateSelected = async () => {
    const sel = Object.keys(selected)
      .filter((k) => selected[k])
      .map((k) => selected[k]);
    const results = await Promise.all(
      sel.map(async (item) => {
        try {
          const realm_id = get(updates, 'location', item.realm.id);
          const quality = get(updates, 'quality', item.quality);
          const relationships = {
            supersets: {
              data: (_size(updates.supersets) || updates.somethingChanged ? updates.supersets : item.supersets).map((s) => ({ type: 'supersets', id: get(s, 'id', s).toString() })),
            },
          };

          const data = {
            data: {
              type: 'realm-photos',
              id: item.id,
              attributes: {
                name: get(item, 'name'),
                assessment_id: get(item, 'assessment.id'),
                realm_id,
                quality,
              },
              relationships,
            },
          };

          const resp = await sendData(
            {
              url: `/realm-photos/${item.id}?${qs.stringify({ include: ['supersets', 'realm', 'assessment'].join(',') })}`,
              method: 'patch',
              data,
            },
            { normalize: { build: ['realmPhotos'] } }
          );
          return resp[0];
        } catch (err) {
          setAlerts({ message: `Patch failed: ${err.message}`, severity: 'error' });
        }
      })
    );
    if (size(results)) {
      if (modal) {
        const sel = { ...selected };
        results.map((r) => {
          if (get(sel, r.id)) {
            set(sel, r.id, r);
          }
        });
        setSelected(sel);
      } else {
        update();
        setUpdates(cleanCopy(defaultUpdates));
        setSelected({});
      }
    }
  };

  useEffect(() => {
    if (!listOpen && (updates.location || updates.quality !== undefined || updates.somethingChanged)) {
      updateSelected();
    }
  }, [updates, listOpen]);

  useEffect(() => {
    props.onSelectedChange && props.onSelectedChange(selected);
  }, [selected]);

  const clickImage = (img, index = 0) => {
    if (img.photos) {
      //is actually folder
      setItems(img.photos);
      setAllItems(img.photos);
      setChosenFolders([img]);
      if (index !== -1) {
        const upd = cleanCopy(defaultUpdates);
        upd.location = get(img, 'photos.0.realm.id');
        setUpdates(upd);
        setSelected({});
      } else if (_size(selected)) {
        //remove from selected images that are no longer in the set
        const sel = {};
        img.photos.map((p) => {
          if (selected[p.id]) {
            set(sel, p.id, p);
          }
        });
        setSelected(sel);
      }
    } else {
      if (searchStat.hasSearched) {
        const ind = items.filter((f) => f.large).findIndex((i) => img.id === i.id);
        setModal({ index: ind });
      } else {
        setModal({ index });
      }
    }
  };

  const clearFolder = (index) => {
    const folds = [...chosenFolders];
    folds.splice(index, 1);
    setChosenFolders(folds);
    setupFolders(true);
    setSelected({});
    setTakeAmt(takeAdd);
  };

  const deleteImage = async (e, img) => {
    stopProp(e);
    const origItems = [...items];
    try {
      const itemIndex = items.findIndex((it) => it.id === img.id);
      items.splice(itemIndex, 1);
      const newItems = [...items];
      setItems(newItems);
      await sendData({
        url: `/realm-photos/${img.id}`,
        method: 'patch',
        data: {
          data: {
            id: img.id,
            type: 'realm-photos',
            attributes: {
              archived: true,
            },
          },
        },
      });
      update();
    } catch (err) {
      console.error(err);
      setItems(origItems);
      setAlerts({
        message: 'Delete Failed',
        severity: 'error',
      });
    }
  };

  const selectImage = (e, img) => {
    stopProp(e);
    const shiftIsSelected = !!get(pressedKeys, '16');
    if (shiftIsSelected && !!_size(selected)) {
      const selIndexes = [];
      items.map((item, i) => {
        if (item.id == img.id || selected[item.id]) {
          selIndexes.push(i);
        }
      });
      const sorted = selIndexes.sort((a, b) => a - b);
      const newselected = {};
      for (let i = first(sorted); i <= last(sorted); i++) {
        const item = items[i];
        newselected[item.id] = item;
      }
      setSelected(newselected);
    } else {
      setSelected((s) => ({ ...s, [img.id]: s[img.id] ? undefined : img }));
    }
  };

  const update = () => {
    get(props, 'update', () => 0)();
  };

  const folderOption = (e, folder, index) => {
    stopProp(e);
    setPopOpen({ index, anchor: e.currentTarget });
  };

  const setFilteredItems = (all = allItems) => {
    all = all.sort((a, b) => {
      const amt = size(a.supersets);
      const bmt = size(b.supersets);

      return amt - bmt;
    });
    let _items = [];
    const v = (debouncedSearch || '').toLowerCase();
    const checks = ['name', 'realm.name', ['photos', 'supersets.0.name'], ['photos', 'name']];

    const addAndCheck = (item) => {
      const cat = get(filts, 'cat') == 'location' ? 'realm' : 'supersets.0';
      const pastItem = last(_items);
      const pastFolder = get(pastItem, `${cat}.id`, 0);
      const thisFolder = get(item, `${cat}.id`, 0);
      if (pastFolder !== thisFolder || pastFolder === 0) {
        _items.push({ id: get(item, `${cat}.name`, 0), divider: { text: get(item, `${cat}.name`, 'None') } });
      }
      _items.push(item);
    };

    all.map((item) => {
      if (debouncedSearch) {
        for (let i = 0; i < checks.length; i++) {
          const c = checks[i];
          if (Array.isArray(c)) {
            // eslint-disable-next-line no-loop-func
            const [first, ...rest] = c;
            get(item, first, []).map((ii) => {
              const val = get(ii, ...rest, '').toLowerCase();
              if (val.indexOf(v) > -1) {
                addAndCheck({
                  ...ii,
                  parentFolder: {
                    ...item,
                  },
                });
              }
            });
          } else {
            if (get(item, c, '').toLowerCase().indexOf(v) > -1) {
              addAndCheck(item);
            }
          }
        }
      } else {
        addAndCheck(item);
      }
    });

    _items = _items.sort((a, b) => {
      const aPhotos = get(a, 'photos', []);
      const bPhotos = get(b, 'photos', []);
      return aPhotos.length > bPhotos.length ? -1 : 1;
    });

    if (filts.tag !== undefined) {
      filterTaggedItems(_items);
    } else {
      setItems(_items, false);
    }
    setSearchStat({ isSearching: false, hasSearched: true });
  };

  useEffect(() => {
    let _allItems = allItems;
    const isNotFiltered = !debouncedSearch && filts.tag === undefined;
    if (isFolders) {
      _allItems = flatten(items.map((it) => it.photos || []));
      setAllItems(_allItems);
    }
    if (isNotFiltered && !get(chosenFolders, '0')) {
      setSearchStat({ isSearching: false, hasSearched: false });
      setupFolders(true);
      return setItems(_allItems, false);
    }

    setTakeAmt(takeAdd);
    setFilteredItems(_allItems);
  }, [debouncedSearch, filts]);

  const changeSearch = (val) => {
    setSearchVal(val);
    setSearchStat((ds) => ({ ...ds, isSearching: true }));
  };

  const closePop = (e) => {
    stopProp(e);
    setPopOpen();
  };

  const confirmDeleteAll = async (img) => {
    setDlStats((dl) => ({
      ...dl,
      isLoading: true,
      id: get(img, 'realm.id'),
      progress: 0,
    }));
    setConfirm();

    const files = get(img, 'photos', []);
    const failed = [];
    await awaitAll(
      files.map((p) => () => async () => {
        try {
          await sendData({
            url: `/realm-photos/${p.id}`,
            method: 'patch',
            data: {
              data: {
                id: p.id,
                type: 'realm-photos',
                attributes: {
                  archived: true,
                },
              },
            },
          });
          setDlStats((dl) => ({
            ...dl,
            progress: dl.progress + 100 / files.length,
          }));
        } catch (err) {
          failed.push(p);
        }
      }),
      { queueSize: 10 }
    );

    setDlStats();

    if (failed.length > 0) {
      setAlerts({
        message: `These photos failed to delete: ${failed.map((f) => f.name).join(', ')}`,
        severity: 'error',
      });
    } else {
      setAlerts({
        message: 'Delete Success',
        severity: 'success',
      });
    }

    setSelected({});
    update();
  };

  const confirmDownload = async (img) => {
    setDlStats((dl) => ({
      ...dl,
      isLoading: true,
      id: get(img, 'realm.id'),
      progress: 0,
    }));
    setConfirm();

    const files = get(img, 'photos', []);

    if (size(files) === 1) {
      await downloadImage(files[0]);
      return setDlStats();
    }

    const b64Array = await Promise.all(
      files.map(async (f) => {
        try {
          const data = await getBase64Image(f.fullUrl);
          setDlStats((dl) => ({
            ...dl,
            progress: dl.progress + 100 / files.length,
          }));
          return {
            ...f,
            data,
          };
        } catch (err) {
          return null;
        }
      })
    );

    const zip = new JSZip();
    b64Array
      .filter((f) => f)
      .forEach((file) => {
        zip.file(file.name, file.data, { base64: true });
      });

    zip.generateAsync({ type: 'blob' }).then((content) => {
      saveAs(content, `${get(img, 'realm.name', get(img, 'realm.id'))}-photos.zip`);
      setDlStats();
    });
  };

  const onDeleteSelected = (e) => {
    closePop(e);
    setConfirm({
      title: 'Delete Selected Images?',
      content: `Are you sure you want to delete the selected images?`,
      onOk: () =>
        confirmDeleteAll({
          realm: { id: 'selectedDelete' },
          photos: items.filter((item) => !!get(selected, item.id)),
        }),
      onCancel: () => setConfirm(),
    });
  };

  const onDeleteAll = (e, img) => {
    closePop(e);
    setConfirm({
      title: 'Delete All Images?',
      content: `Are you sure you want to delete all images in ${img.realm.name}?`,
      onOk: () => confirmDeleteAll(img),
      onCancel: () => setConfirm(),
    });
  };

  const onDownloadAll = (e, img) => {
    closePop(e);
    setConfirm({
      title: 'Download All Images?',
      content: `Are you sure you want to download all images in ${img.realm.name}?`,
      onOk: () => confirmDownload(img),
      onCancel: () => setConfirm(),
    });
  };

  const updateSuperset = (supe) => {
    const sups = [...get(updates, 'supersets', [])];
    const ind = sups.indexOf(supe.id);
    if (ind > -1) {
      sups.splice(ind, 1);
    } else {
      sups.push(supe.id);
    }
    setUpdates((u) => ({ ...u, supersets: sups, somethingChanged: true }));
  };

  const renderChosen = () => {
    return (chosenFolders || []).map((cf, i) => (
      <Button key={cf.id} disableElevation size="small" onClick={() => clearFolder(i)} bgColor={colors.darkGrey}>
        <div className={classes.chosenFolder}>
          <p className={classes.cfTitle}>{get(cf, 'realm.name', '')}</p>
          <p className={classes.cfSize}>{`${size(items.filter((i) => !get(i, 'divider')))} photos`}</p>
          <IconButton className={classes.closeFolder}>
            <Icon>close</Icon>
          </IconButton>
        </div>
      </Button>
    ));
  };

  const updatesAreEqual = () => {
    return isEqual(updates, modalRefs.current);
  };

  const onOpenList = (_list) => {
    let list = _list;
    if (_list === 'location') {
      list = 'realm';
    }

    setListOpen(true);
    const totalSelected = _size(selected);
    const compareItem = get(selected, Object.keys(selected)[0]);
    const areEqual = _size(Object.keys(selected).filter((k) => isEqual(get(selected, [k, list]), get(compareItem, [list])))) == totalSelected;

    if (areEqual) {
      const upd = { ...updates };
      const updItem = get(compareItem, list);
      set(upd, _list, Array.isArray(updItem) ? updItem.map((l) => l.id) : isObject(updItem) ? get(updItem, 'id') : updItem);
      setUpdates({ ...upd });
    }
  };

  const onCloseList = (list) => {
    setListOpen(false);
  };

  const blankContent = () => {
    if (props.blankContent) {
      return props.blankContent();
    }

    return null;
  };

  const selectedSize = size(Object.keys(selected).filter((k) => selected[k]));

  const curSel = get(selected, Object.keys(selected)[0]);

  const showCtxt = userCanEdit && !!selectedSize && !modal;

  const canSelect = userCanEdit || props.canSelect;

  return (
    <>
      {userCanEdit && (!_size(selected) || modal) && (
        <div className={classes.buttonRow}>
          <Button className={classes.button} variant="contained" color="secondary" onClick={uploadPhotos} startIcon={<Icon>cloud_upload</Icon>}>
            {isMobile ? 'Upload' : 'Upload Photos'}
          </Button>
          <Button className={classes.button} variant="contained" color="secondary" onClick={download} startIcon={<Icon>cloud_download</Icon>}>
            {'Download'}
            {props.dlStats ? <CircularProgress variant="determinate" color="inherit" size={16} value={props.dlStats.progress} /> : null}
          </Button>
        </div>
      )}
      <div ref={btnRef} />
      {showCtxt && (
        <div className={clsx(classes.selectedRow, ctxtBtnsFixed && classes.selectRowFixed)}>
          <PhotosGrid>
            <div className={classes.row}>
              <IconButton onClick={() => setSelected({})}>
                <Icon>close</Icon>
              </IconButton>
              <div>{`${selectedSize} Selected`}</div>
              <div className={classes.selButtonRow}>
                <MoreList
                  icon="label"
                  type="checkbox"
                  onOpen={() => onOpenList('supersets')}
                  onClose={() => onCloseList('supersets')}
                  title={
                    <>
                      <Icon style={{ marginRight: 5 }}>label</Icon>Update System
                    </>
                  }
                  options={props.supersets.map((r) => ({ title: r.name, selected: get(updates, 'supersets', []).indexOf(r.id) > -1, onClick: () => updateSuperset(r) }))}
                />

                <MoreList
                  icon="location_on"
                  onOpen={() => onOpenList('location')}
                  onClose={() => onCloseList('location')}
                  title={
                    <>
                      <Icon style={{ marginRight: 5 }}>location_on</Icon>Update Location
                    </>
                  }
                  options={props.realms.map((r) => ({ title: r.name, selected: get(updates, 'location') == r.id, onClick: () => setUpdates((u) => ({ ...u, location: r.id })) }))}
                />

                <MoreList
                  icon="thumbs_up_down"
                  onOpen={() => onOpenList('quality')}
                  onClose={() => onCloseList('quality')}
                  title={
                    <>
                      <Icon style={{ marginRight: 5 }}>thumbs_up_down</Icon>Update Quality
                    </>
                  }
                  options={[
                    { title: 'Best Practice', selected: get(updates, 'quality') === 1, onClick: () => setUpdates((u) => ({ ...u, quality: 1 })) },
                    { title: 'Quality Opportunity', selected: get(updates, 'quality') === 0, onClick: () => setUpdates((u) => ({ ...u, quality: 0 })) },
                    { title: 'None', selected: get(updates, 'quality') === null, onClick: () => setUpdates((u) => ({ ...u, quality: null })) },
                  ]}
                />
                <div className={classes.vr} />
                <Button
                  variant="contained"
                  onClick={() => confirmDownload({ realm: { id: `Selected-${new Date().toISOString()}` }, photos: items.filter((item) => !!get(selected, item.id)) })}
                  disableElevation
                  size="small"
                  startIcon={get(dlStats, 'id', '').indexOf('Selected-') > -1 ? <Loader size={14} /> : <Icon>save_alt</Icon>}
                  className={clsx(classes.selButton)}
                >
                  Download
                </Button>
                <div className={classes.vr} />
                <Button
                  variant="contained"
                  onClick={onDeleteSelected}
                  disableElevation
                  size="small"
                  startIcon={get(dlStats, 'id') === 'selectedDelete' ? <Loader size={14} /> : <Icon>delete</Icon>}
                  bgColor={colors.danger}
                  className={clsx(classes.selButton, classes.selDelete)}
                >
                  Delete
                </Button>
              </div>
            </div>
          </PhotosGrid>
        </div>
      )}

      {includeSearch && (
        <div className={classes.searchContainer} style={{ marginTop: showCtxt ? (isMobile ? 150 : 80) : undefined }}>
          <SearchBar onClear={() => changeSearch('')} loading={get(searchStat, 'isSearching', false)} searchString={searchVal} changeSearch={changeSearch} />
        </div>
      )}

      <div className={classes.foldersRow}>
        {!isMobile && renderChosen()}

        {!props.hideSuperset && (
          <Select className={styles.select} disableUnderline variant="filled" value={filts.cat} onChange={(e) => setFilts((f) => ({ ...f, cat: e.target.value }))}>
            {catOptions.map((l, i) => (
              <MenuItem key={i} value={get(l, 'id')}>
                {get(l, 'title')}
              </MenuItem>
            ))}
          </Select>
        )}
        <div className={classes.filterRow}>
          <Button
            bgColor={get(filts, 'tag') === undefined ? undefined : colors.lightGreyBorder}
            onClick={() => setFilts((f) => ({ ...f, tag: undefined }))}
            disableElevation
            size="small"
            variant="contained"
          >
            ALL
          </Button>
          <Button bgColor={get(filts, 'tag') === 1 ? undefined : colors.lightGreyBorder} onClick={() => setFilts((f) => ({ ...f, tag: 1 }))} disableElevation size="small" variant="contained">
            <Icon className={classes.pos}>thumb_up</Icon>
          </Button>
          <Button bgColor={get(filts, 'tag') === 0 ? undefined : colors.lightGreyBorder} onClick={() => setFilts((f) => ({ ...f, tag: 0 }))} disableElevation size="small" variant="contained">
            <Icon className={classes.neg}>thumb_down</Icon>
          </Button>
          <Button
            bgColor={get(filts, 'tag') === 'both' ? undefined : colors.lightGreyBorder}
            onClick={() => setFilts((f) => ({ ...f, tag: 'both' }))}
            disableElevation
            size="small"
            variant="contained"
          >
            <Icon>thumbs_up_down</Icon>
          </Button>
          <Button bgColor={get(filts, 'tag') === null ? undefined : colors.lightGreyBorder} onClick={() => setFilts((f) => ({ ...f, tag: null }))} disableElevation size="small" variant="contained">
            <Icon>cancel_presentation</Icon>
          </Button>
        </div>
      </div>

      {isMobile && <div className={classes.foldersRow}>{renderChosen()}</div>}

      {props.loading && <LinearProgress color="primary" />}
      <GridList className={classes.gridList} cellHeight={200} spacing={16}>
        {!get(searchStat, 'isSearching') &&
          take(items, takeAmt).map((img, i) => {
            const isFolder = get(img, 'photos');
            const prevImg = get(items, [i - 1]);
            const prevImage = get(prevImg, 'photos');
            const divide = !isFolder && prevImage && searchVal && !get(searchStat, 'isSearching');
            const divider = get(img, 'divider');
            const HasIcon = get(img, 'icon');
            const isSelected = !!get(selected, img.id);

            const imageSel = isSelected && !modal;

            return divider ? (
              <div key={`divider_${i}`} className={classes.hrDivider}>
                {divider.text}
              </div>
            ) : (
              <ImageListItem
                className={clsx(isFolder ? classes.gridListFolder : classes.gridTile, divide && classes.divider, imageSel && classes.gridTileSelected)}
                onClick={!!selectedSize ? (e) => selectImage(e, img) : () => clickImage(img, i)}
                key={img.id}
              >
                {HasIcon ? (
                  <HasIcon className={classes.imgContainer} />
                ) : (
                  <Image width={imageSel ? 176 : 200} className={classes.imgContainer} src={img.thumb} backupSrc={img.large} autosize={0} alt={img.name} />
                )}

                {!isFolder && (
                  <>
                    {canSelect && (
                      <IconButton
                        classes={{ root: classes.iconRoot }}
                        onClick={(e) => selectImage(e, img)}
                        className={clsx(classes.checkIcon, imageSel && classes.checkIconSelected, !!selectedSize && classes.checkIconSelectMode)}
                      >
                        {imageSel ? <CheckBox /> : <CheckBoxOutlineBlankOutlined />}
                      </IconButton>
                    )}

                    <PhotoText img={img} isSelected={imageSel} />
                  </>
                )}

                {isFolder && (
                  <ImageListItemBar
                    title={highlightedText(`${get(img, 'realm.name', '')}`, searchVal)}
                    subtitle={<span>{`${size(img.photos)} photos`}</span>}
                    classes={{ root: classes.titleBar }}
                    actionIcon={
                      !userCanEdit ? undefined : (
                        <>
                          {dlStats && dlStats.id === get(img, 'realm.id') ? (
                            <IconButton className={classes.icon}>
                              <CircularProgress color="inherit" variant="determinate" size={22} value={dlStats.progress} />
                            </IconButton>
                          ) : (
                            <IconButton onClick={(e) => folderOption(e, img, i)} aria-label={`info about ${img.name}`} className={classes.icon}>
                              <Icon>more_vert</Icon>
                            </IconButton>
                          )}
                          <Popover className={classes.popOver} open={get(popOpen, 'index') === i} anchorEl={get(popOpen, 'anchor')} onClose={closePop}>
                            <ButtonGroup orientation="vertical" variant="contained" color="secondary">
                              {userCanEdit && (
                                <Button startIcon={<Icon>delete</Icon>} onClick={(e) => onDeleteAll(e, img)}>
                                  Delete All
                                </Button>
                              )}
                              <Button startIcon={<Icon>cloud_download</Icon>} onClick={(e) => onDownloadAll(e, img)}>
                                Download
                              </Button>
                            </ButtonGroup>
                          </Popover>
                        </>
                      )
                    }
                  />
                )}
              </ImageListItem>
            );
          })}
        {!get(searchStat, 'isSearching') && size(items) === 0 && !props.loading && blankContent()}
        <div ref={ref} />
      </GridList>

      <Confirm {...confirm} />

      <ModalGateway
        open={modal}
        onClose={() => {
          setModal();
          setSelected({});
          if (!updatesAreEqual()) {
            update();
          }
        }}
        currentIndex={get(modal, 'index')}
        onPhoto={(img) => {
          const upd = cleanCopy(defaultUpdates);
          set(
            upd,
            'supersets',
            get(img, 'supersets', []).map((s) => s.id)
          );
          modalRefs.current = upd;
          setUpdates(upd);
          setSelected({ [img.id]: img });
        }}
        toolbarButtons={[
          userCanEdit && (
            <div className={clsx(classes.toolBtn)}>
              <MoreList
                icon="label"
                bgColor={'#000'}
                type="checkbox"
                preventClose
                title={
                  <>
                    <Icon style={{ marginRight: 5 }}>label</Icon>Update System
                  </>
                }
                options={props.supersets.map((r) => ({
                  title: r.name,
                  selected:
                    get(curSel, 'supersets', [])
                      .map((s) => s.id)
                      .indexOf(r.id) > -1,
                  onClick: () => updateSuperset(r),
                }))}
              />
            </div>
          ),
          userCanEdit && (
            <div className={clsx(classes.toolBtn, classes.tool1)}>
              <MoreList
                icon="location_on"
                bgColor={'#000'}
                preventClose
                title={
                  <>
                    <Icon style={{ marginRight: 5 }}>location_on</Icon>Update Location
                  </>
                }
                options={(props.realms || []).filter((r) => r).map((r) => ({ title: r.name, selected: get(curSel, 'realm.id') == r.id, onClick: () => setUpdates((u) => ({ ...u, location: r.id })) }))}
              />
            </div>
          ),
          userCanEdit && (
            <div className={clsx(classes.toolBtn, classes.tool2)}>
              <MoreList
                icon="thumbs_up_down"
                preventClose
                bgColor={'#000'}
                title={
                  <>
                    <Icon style={{ marginRight: 5 }}>thumbs_up_down</Icon>Update Quality
                  </>
                }
                options={[
                  { title: 'Best Practice', selected: get(curSel, 'quality') === 1, onClick: () => setUpdates((u) => ({ ...u, quality: 1 })) },
                  { title: 'Quality Opportunity', selected: get(curSel, 'quality') === 0, onClick: () => setUpdates((u) => ({ ...u, quality: 0 })) },
                  { title: 'None', selected: get(curSel, 'quality') === null, onClick: () => setUpdates((u) => ({ ...u, quality: null })) },
                ]}
              />
            </div>
          ),
          <div className={clsx(classes.toolBtn, classes.tool3)}>
            <Button
              variant="contained"
              onClick={() => confirmDownload({ realm: { id: `Selected-${new Date().toISOString()}` }, photos: items.filter((item) => !!get(selected, item.id)) })}
              disableElevation
              size="small"
              bgColor={'#000'}
            >
              {get(dlStats, 'id', '').indexOf('Selected-') > -1 ? <Loader size={14} /> : <Icon>save_alt</Icon>}
            </Button>
          </div>,
        ].filter((f) => !!f)}
        images={items
          .filter((p) => p.large)
          .map((x) => ({
            ...x,
            key: x.id,
            src: x.large,
            caption: <PhotoText img={x} style={{ position: 'relative', backgroundColor: 'transparent' }} />,
          }))}
      />

      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={alerts}
        autoHideDuration={6000}
        onClose={() => setAlerts()}
      >
        <Alert onClose={() => setAlerts()} severity={get(alerts, 'severity', 'success')}>
          {get(alerts, 'message', '')}
        </Alert>
      </Snackbar>
    </>
  );
};

const PhotoText = (props) => {
  const { img, isSelected } = props;
  const classes = useStyles();

  const style = get(props, 'style', {});

  const hasQuality = get(img, 'quality') !== null && get(img, 'quality') !== undefined;
  const isBp = hasQuality && img.quality === 1;

  let icon = hasQuality ? <Icon className={isBp ? 'pos' : 'neg'}>{isBp ? 'thumb_up' : 'thumb_down'}</Icon> : getRealmIcon(img.realm);
  let title = get(img, 'name');
  let subtitle = get(img, 'supersets.0.name', get(img, 'realm.name'));

  return (
    <div id={'photoText'} className={clsx(classes.photoText, isSelected && classes.photoTextSelected)} style={style}>
      <div className="icon">{icon}</div>
      <div className="textContainer">
        <div className="title">{title}</div>
        {!!subtitle && <div className="subtitle">{subtitle}</div>}
      </div>
    </div>
  );
};

ImageGrid.defaultProps = {
  supersets: [],
  realms: [],
};

export default ImageGrid;
